<template>
  <div class="content">
    <div
      class="invoice-wrapper rounded border bg-white py-5 px-3 px-md-4 px-lg-5"
      v-if="null !== invoice"
    >
      <div class="d-flex justify-content-between">
        <img
          :src="nzidoo_logo"
          width="100"
          height="80"
        />
        <h2 class="text-dark font-weight-medium">{{ invoice.title }}</h2>
        <div class="btn-group">
          <a
            :href="downloadUrl + 'order/' + orderId + '/download/' + type"
            class="btn btn-sm btn-secondary"
          >
            <i class="mdi mdi-content-save"></i> {{ $t("action.save") }}
          </a>
          <a
            :href="downloadUrl + 'order/' + orderId + '/print/' + type"
            class="btn btn-sm btn-secondary"
            target="_blank"
          >
            <i class="mdi mdi-printer"></i> {{ $t("action.print") }}
          </a>
        </div>
      </div>
      <div class="row pt-5">
        <div class="col-xl-3 col-lg-4">
          <p class="text-dark mb-2">From</p>

          <address v-if="invoice.store_name !== null">
            {{ invoice.store_name }}
            <br />
            {{ invoice.store_address }} <br />
            {{ $t("attr.phone") }}: {{ invoice.store_phone }}
          </address>
          <address v-else>
            {{ invoice.seller_firstName }} {{ invoice.seller_lastName }}
            <br />
            {{ invoice.seller_address }} <br />
            {{ $t("attr.email") }}: {{ invoice.seller_email }} <br />
            {{ $t("attr.phone") }}: {{ invoice.seller_phone }}
          </address>
        </div>
        <div class="col-xl-3 col-lg-4">
          <p class="text-dark mb-2">To</p>
          <address>
            {{ invoice.buyer_firstName }} {{ invoice.buyer_lastName }}
            <br />
            {{ invoice.buyer_address }} <br />
            {{ $t("attr.phone") }}: {{ invoice.buyer_phone }}
          </address>
        </div>
        <div class="col-xl-3 col-lg-4">
          <p class="text-dark mb-2">Details</p>
          <address>
            {{ $t("attr.invoice") }} ID:
            <span class="text-dark">#2365546</span>
            <br />
            {{ invoice.today }} <br />
            VAT: PL6541215450
          </address>
        </div>
      </div>
      <table
        class="table mt-3 table-striped table-responsive table-responsive-large"
        style="width:100%"
      >
        <thead>
          <tr>
            <th>#</th>
            <th>{{ $t("attr.item") }}</th>
            <th>{{ $t("ecommerce.product.quantity") }}</th>
            <th>{{ $t("ecommerce.product.price") }}</th>
            <th>{{ $t("ecommerce.product.totalPrice") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>{{ invoice.product_name }}</td>
            <td>{{ invoice.quantity }}</td>
            <td>{{ invoice.price }}</td>
            <td>{{ invoice.price * invoice.quantity }} DA</td>
          </tr>
        </tbody>
      </table>
      <div class="row justify-content-end">
        <div class="col-lg-5 col-xl-4 col-xl-3 ml-sm-auto">
          <ul class="list-unstyled mt-4">
            <li class="mid pb-3 text-dark">
              {{ $t("ecommerce.product.subTotal") }}

              <span
                class="d-inline-block float-right text-default"
                v-if="type === 'SALES_INVOICES'"
              >
                {{
                  invoice.price *
                    (invoice.quantity === null ? 1 : invoice.quantity) -
                    (invoice.price *
                      (invoice.quantity === null ? 1 : invoice.quantity) *
                      12) /
                      100
                }}
                DA</span
              >
              <span class="d-inline-block float-right text-default" v-else>
                {{
                  invoice.price *
                    (invoice.quantity === null ? 1 : invoice.quantity)
                }}
                DA</span
              >
            </li>
            <li class="mid pb-3 text-dark">
              <span v-if="type === 'SALES_INVOICES'" style="line-break:strict"
                >{{ $t("ecommerce.product.tax") }} (12%)</span
              >
              <span v-else style="line-break:strict"
                >{{ $t("ecommerce.product.noTax") }}
              </span>
              <span
                v-if="type === 'SALES_INVOICES'"
                class="d-inline-block float-right text-default"
                >{{
                  (invoice.price *
                    (invoice.quantity === null ? 1 : invoice.quantity) *
                    12) /
                    100
                }}
                DA</span
              >
            </li>
            <li class="pb-3 text-dark">
              Total
              <span class="d-inline-block float-right"
                >{{
                  invoice.price *
                    (invoice.quantity === null ? 1 : invoice.quantity)
                }}
                DA</span
              >
            </li>
          </ul>
          <!-- <a href="#" class="btn btn-block mt-2 btn-lg btn-primary btn-pill">
            Procced to Payment</a
          > -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config.js";
import nzidoo_logo from "@/assets/img/nzidoo-logo.png";

export default {
  mounted() {
    if (this.$route.params.orderId != undefined) {
      this.getDataInvoices(this.$route.params.orderId, this.$route.params.type);
      this.type = this.$route.params.type;
    }
  },
  data() {
    return {
      nzidoo_logo: nzidoo_logo,
      invoice: null,
      type: null,
      orderId: this.$route.params.orderId,
      downloadUrl: config.baseUrl,
    };
  },
  methods: {
    getDataInvoices(orderId, type) {
      var self = this;
      this.$axios({
        url: "order/" + orderId + "/show/" + type,
        method: "GET",
      })
        .then((response) => {
          self.invoice = response.data;
          console.log(response.data);
        })
        .catch();
    },
  },
};
</script>
